import { NodeViewWrapper } from '@tiptap/react'
import React from 'react'

export default () => {
  return (
    <NodeViewWrapper className="event-services">
      <div className="editor-auto-populated-section">Services for this event will automatically populate here.</div>
    </NodeViewWrapper>
  )
}